import React, { useState, useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import * as rdd from 'react-device-detect';
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import "../assets/css/form.css";
import QuestionIcon from "../assets/img/question-icon.png";
import GrayTick from "../assets/img/gray-tick-icon.png";
import GreenTickBig from "../assets/img/green-tick-big.svg";
import QRSample from "../assets/img/qrcode 1.png";
import Footer from "./Footer.js";
import Loader from "./Common/loader";
import { toast } from "react-toastify";
import GetMasterData from "../Helper/masterData";
import StepCount from "./Common/StepCount";
import _ from "lodash";
import "../assets/css/custom-modal.css";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";

import { getDAVData, SendLinkData, getDAVStatus } from "../Actions/DAVAction";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const DigitalAddressVerification = () => {
  const davStore = useSelector((state) => state?.DAV);
  const StatusData = useSelector((state) => state?.DAV?.StatusData);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {reference} = useParams();

  const [saveDisabled, setSaveDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timerCount, setTimerCount] = useState(30);
  const [davPopUp, setDAVPopUp] = useState(false);
  const [davStatusCall, setDAVStatusCall] = useState(false);
  // const [timeInterval, setTimeInterval] = useState(null);
  const [role,setRole]=useState();

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  const fetchData = async () => {
      const payloadForQr = {
        "device_type":`${!!(rdd.isMobile) ? 'mobile' : 'desktop'}`,
        "call_back_url": window.location.href
      }
    const checkStatus = true
    dispatch(getDAVData(payloadForQr, checkStatus));
    };

  const SendLink = () => {
    dispatch(SendLinkData());
    setTimerCount(30);
    setDAVStatusCall(false);
  };

  const redirectTo = (page) => {
    //   navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
    navigate(`/case-initiation/${page}/${reference}`);
  };

  const startDAVStatusCall = () => {
    const callInterval = setInterval(() => {
      dispatch(getDAVStatus())
    },15000);
    sessionStorage.setItem('davStatusCallInterval', callInterval);
  }

  const stopDAVStatusCall = () => {
    const interval = sessionStorage.getItem('davStatusCallInterval')
    clearInterval(interval);
}

  const startTimer = () => {
    const interval = setInterval(() => {
      setTimerCount(prevState => prevState -1)
    }, 1000);
    sessionStorage.setItem('resendInterval', interval)
  }

  const stopTimer = () => {
      const interval = sessionStorage.getItem('resendInterval')
      clearInterval(interval);
  }

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {   
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);


  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    return () => {
      stopTimer();
    }
  }, []);

  useEffect(() => {
    fetchData();

    return () => {
      stopTimer();
      stopDAVStatusCall();
    }
  }, []);

  useEffect(() => {
    if (davStore?.loading) {
      setIsLoading(true);
    } else {
      setIsLoading(false)
    }
    if(!!(davStore?.SentLinkData?.status && davStore?.SentLinkData?.code)){
      startTimer();
    } else {
      stopTimer();
    }
    if(davStore?.SentLinkData?.status?.toUpperCase() === 'SUCCESS' 
    && davStore?.SentLinkData?.message){
      setSaveDisabled(false);
    }
    if(davStore?.DAVData?.data){
      //do Nothing
    }
    else if (davStore?.DAVData?.code && davStore?.DAVData?.code === 400) {
      const msg = davStore?.DAVData?.data?.message;
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      const localData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      navigate(role === "EP"
      ?`/case-initiation/check-detail/${reference || localData.reference_number}/candidate-profile`
      :`/case-initiation/check-detail/${reference || localData.reference_number}/profile`)
      // navigate(
      //   `/case-initiation/check-detail/${localData.reference_number}/profile`
      // );
    }
  },[davStore])

  useEffect(() => {
    if(StatusData?.check_status?.toUpperCase() == 'COMPLETED') {
      setDAVPopUp(true);
    } else {
      setDAVPopUp(false);
    }
    if (StatusData?.check_status
      && (!(StatusData?.step))
      && StatusData?.qr_code_scanned?.toUpperCase() === 'NO'
      && !davStatusCall) {
      setDAVStatusCall(true);
    }
    if(StatusData?.check_status && (!(StatusData?.step))) {
      setSaveDisabled(true);
    }
    if(StatusData?.check_status && StatusData?.qr_code_scanned?.toUpperCase() === 'YES'){
      setSaveDisabled(false);
      setDAVStatusCall(false);
    }
    if(StatusData?.check_status && (StatusData?.step)){
      setSaveDisabled(false);
      setDAVStatusCall(false);
    }
  },[StatusData])

  useEffect(()=>{
    if(timerCount <= 0){
      stopTimer();
    }
  },[timerCount])

  useEffect(() => {
    if(davStatusCall) {
      startDAVStatusCall();
    } else {
      stopDAVStatusCall();
    }
  },[davStatusCall])

  const handleSave = (e) => {
    e.preventDefault();
    redirectTo('profile-preview');
    const saveDAV=true;
    dispatch(getDAVStatus({
      'saveDAV' : true,
      'showStatus': true
    }));
  };

  // const { genderOptions } = GetMasterData();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    phone : null,
    email : null,
    email2 : null,
    name : null,
    name2 : null
  });

  //Handling Floating Labels
  const handleFloatingLabels = (e)=> {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    redirectTo('profile-preview');
  };

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {isLoading && <Loader />}
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Digital Address"} />
            </div>
            <div className="col bg-gray-mbl">
              <form
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <StepCount activeTab={"Digital Address"} />
                <h2 className="fnt-smi-bld">Digital Address Verification</h2>
                <p className="text-muted">
                  {
                    !(rdd.isMobile) 
                    ? `To do digital address verification, please scan this QR code with your phone or generate link.` 
                    : `To do digital address verification, please click 'Get Started' button or generate link.`
                  }
                </p>
                <hr />
                <div className="step-1">
                  <h5 className="fnt-smi-bld mb-3">
                    Prepare a valid documents for
                  </h5>
                  <div class="row">
                    <div class="col-xs-12 col-lg-4 col-md-12 col-sm-4 fnt-sml-md">
                      <h6 class="fnt-smi-bld mb-3">Identity Proof Documents</h6>
                      <p class="text-muted mb-1 d-flex align-items-baseline">
                        <img src={GrayTick} class="mr-2" alt=""/>
                        Aadhaar Card
                      </p>
                      <p class="text-muted mb-1 d-flex align-items-baseline">
                        <img src={GrayTick} class="mr-2" alt=""/>
                        Pan Card
                      </p>
                      <p class="text-muted mb-1 d-flex align-items-baseline">
                        <img src={GrayTick} class="mr-2" alt=""/>
                        Passport
                      </p>
                    </div>
                    <div class="col-xs-12 col-lg-4 col-md-12 col-sm-4 fnt-sml-md">
                      <h6 class="fnt-smi-bld mb-3">Address Proof Documents</h6>
                      <p class="text-muted mb-1 d-flex align-items-baseline">
                        <img src={GrayTick} class="mr-2" alt=""/>
                        Aadhaar Card
                      </p>
                      <p class="text-muted mb-1 d-flex align-items-baseline">
                        <img src={GrayTick} class="mr-2" alt=""/>
                        Pan Card
                      </p>
                      <p class="text-muted mb-1 d-flex align-items-baseline">
                        <img src={GrayTick} class="mr-2" alt=""/>
                        Passport
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  {
                    !(role == "EP") && 
                    <>
                    {
                    !(rdd.isMobile) ? <div class="col-xs-12 col-lg-4 col-md-12 col-sm-4">
                    <div class="common-box p-3 mb-3" style={{minHeight:'360px'}}>
                      <h5 class="fnt-smi-bld">Option 1: Scan the QR code</h5>
                      <p>Scan the QR code below with a smart phone to continue verification</p>
                      <div class="text-center">
                        {/* <img src={QRSample} alt=""/> */}
                        {
                          davStore?.DAVData?.data?.url 
                          && davStore?.StatusData?.check_status
                          && davStore?.StatusData?.check_status?.toUpperCase() != 'COMPLETED' ?
                            <div style={{ height: "auto", margin: "auto", maxWidth: 150, width: "100%", marginTop: '12%' }}>
                              <QRCode
                                title={'SCAN QR'}
                                value={davStore?.DAVData?.data?.url}
                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                size={256}
                                viewBox={`0 0 256 256`}
                              />
                            </div> : <>
                                {
                                      <div 
                                      className="row m-auto"
                                      style={{
                                        height:160,
                                        alignContent: 'center',
                                        justifyContent: 'center'
                                      }}
                                      >{
                                        isLoading 
                                        ? <></>
                                        // ? <span className={`fa fa-spinner fa-pulse fa-5x fa-fw`} style={{color: '#007bff'}}></span>
                                        : 
                                        <button 
                                        className="btn btn-block mt-3 btn-login"
                                        style={{
                                          background: `linear-gradient(90deg, #475467 0%, #667085 100%)`,
                                          boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05)`,
                                          borderRadius: `8px`,
                                          borderColor:`#667085`,
                                          color:`#FFFFFF`,
                                          maxWidth: 150
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if(davStore?.StatusData?.check_status?.toUpperCase() == 'COMPLETED'){
                                            dispatch(getDAVStatus());
                                          } else {
                                            fetchData();
                                          }
                                        }}>
                                          <span>
                                            <span className={`fa fa-refresh`}></span>
                                            <span className="title ml-1">Refresh</span>
                                          </span>
                                        </button>                                       
                                      }
                                      </div>
                                }
                            </>
                        }
                      </div>
                    </div>
                  </div> : <div class="col-xs-12 col-lg-4 col-md-12 col-sm-4">
                    <div class="common-box p-3 mb-3" style={{minHeight:'360px'}}>
                      <h5 class="fnt-smi-bld">Option 1: Click the Direct link</h5>
                      <p>Please click the button to continue verification</p>
                      <div class="text-center">
                        {/* <img src={QRSample} alt=""/> */}
                            {
                              davStore?.DAVData?.data?.url
                              &&
                              <div className="row m-auto" style={{
                                height:160,
                                alignContent: 'center',
                                justifyContent: 'center'
                              }}>
                                <button
                                  className="btn btn-primary btn-block mt-3 btn-login"
                                  disabled={davStore?.StatusData?.check_status
                                    && davStore?.StatusData?.check_status?.toUpperCase() == 'COMPLETED'}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    window.open(davStore?.DAVData?.data?.url, '_blank', 'noopener,noreferrer')
                                  }}
                                >Get Started</button>
                              </div>
                            }
                      </div>
                    </div>
                  </div>
                  }
                    </>
                  }
                  <div class="col-xs-12 col-lg-4 col-md-12 col-sm-4">
                    {
                      !!(davStore?.SentLinkData?.status)
                        ? <>
                          <div class="common-box p-3 form-2" style={{ minHeight: '360px'}}>
                            <h5 class="fnt-smi-bld">Link Sent!</h5>
                            <p class="">Please check your inbox and mailbox for the link</p>
                            <div className="w-100">
                              <div className="form-group">
                                <div className="floating-label">
                                  <input type="text" className="form-control" name="phone" id="phone" onChange={handleFloatingLabels} value={davStore?.DAVData?.data?.mobile_number || ''} readonly="" />
                                  <label htmlFor="phone" className={'focused'}>Phone No</label>
                                </div>
                              </div>
                              <div className="form-group">
                                <div className="floating-label">
                                  <input type="text" className="form-control" name="email" id="email" onChange={handleFloatingLabels} value={davStore?.DAVData?.data?.email || ''} readonly="" />
                                  <label htmlFor="email" className={'focused'}>Email</label>
                                </div>
                              </div>
                              <button
                                className="btn btn-primary btn-block mt-3 btn-login w-100"
                                disabled={!(timerCount == 0)}
                                onClick={(e) => {
                                  e?.preventDefault();
                                  SendLink();
                                }}
                              >
                                Send Link
                              </button>
                              {
                                !!(timerCount) &&
                                <div class="d-flex justify-content-between mt-2">
                                  <span class="fnt-sml-md">Link not received?</span>
                                  <a href="#" class="text-blue fnt-sml-md" onClick={(e) => e.preventDefault()}>{`Resend in ${timerCount} Sec ...`}</a>
                                </div>
                              }
                              
                            </div>
                          </div>
                        </>
                        : <>
                          <div class="common-box p-3 form-1" style={{ minHeight: '360px', display: 'block' }}>
                            {
                              !(role == 'EP') ? 
                              <h5 class="fnt-smi-bld">Option 2: Generate Link</h5> 
                              :
                              <h5 class="fnt-smi-bld">Option : Generate Link</h5>
                            }
                            <p class="">We’ll text as secure link to you as SMS & Email</p>
                            <div className="w-100">
                              <div className="form-group">
                                <div className="floating-label">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="phone" id="phone"
                                    onChange={handleFloatingLabels}
                                    value={davStore?.DAVData?.data?.mobile_number || ''}
                                    disabled={true}
                                  />
                                  <label htmlFor="phone" className={!!(formData.phone || davStore?.DAVData?.data?.mobile_number) && 'focused'}>Phone No</label>
                                </div>
                              </div>
                              <div className="form-group">
                                <div className="floating-label">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="email"
                                    id="email"
                                    onChange={handleFloatingLabels}
                                    value={davStore?.DAVData?.data?.email || ''}
                                    disabled={true}
                                  />
                                  <label htmlFor="email" className={!!(formData.email || davStore?.DAVData?.data?.email) && 'focused'}>Email</label>
                                </div>
                              </div>

                              <button
                                className="btn btn-primary btn-block mt-3 btn-login w-100"
                                disabled={!(davStore?.DAVData?.data?.email || davStore?.DAVData?.data?.mobile_number) 
                                  || (davStore?.StatusData?.check_status?.toUpperCase() == 'COMPLETED')}
                                onClick={(e) => {
                                  e?.preventDefault();
                                  SendLink();
                                }}
                              >
                                Send Link
                              </button>
                            </div>
                          </div>
                        </>
                    }
                  </div>
                </div>

                <div class="row mt-3 remind-me-text">
                  <div class="col-8 text-center">
                    {/* <a href="#" className="text-blue fnt-smi-bld">Remind me later</a> */}
                    <p class="text-muted mt-2">If you are facing any issues reach out to us at +91 7042856665 or write us at <u>footsupport@authbridge.com</u></p>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Back
                    </button> */}
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      disabled={saveDisabled}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSave(e)
                      }}
                    >
                      {
                        davStore?.StatusData?.check_status?.toUpperCase() == 'COMPLETED' ? 'Save & Continue' : 'Save'
                      }
                    </button>
                  </div>
                </div>
                {
                  !!(davStore?.DAVData?.data?.showProfilePreview) &&
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                }
              </form>

              <Footer />
            </div>
          </div>
        </div>
      </section>

      <div
          className={`dashboard custom-modal-dialog ${davPopUp ? 'show' : 'hide'}`}
          id="DAVthankYouPopup"
        >
          <div className="modal-wrapper">
            <div className="modal-content candidate-tab-form p-4 no-scroll" style={{ overflow: "unset" }}>
              <span className="cstm-popup-close-btn" onClick={(e) => {
                e?.preventDefault();
                setDAVPopUp(false);
              }}>
              &times;
            </span>
              <center>
                <img src={GreenTickBig} class="mb-3" alt=""/>
                <h3 class="fnt-bld mt-3 mb-3">Thank you</h3>
                <p class="text-muted">DAV journey has been completed successfully!</p>
                <p class="text-muted">Please click "Save & Continue" button</p>
              </center>
            </div>
          </div>
        </div>

      <div
          className="dashboard custom-modal-dialog hide"
          id="remindLaterPopup"
        >
          <div className="modal-wrapper">
            <div className="modal-content p-4 no-scroll" style={{ overflow: "unset", maxHeight: "unset" }}>
              <h4 className="fnt-smi-bld auth-header">
                When you will verify
              </h4>
              <span className="cstm-popup-close-btn">
              &times;
            </span>
              <p class="text-muted">Please select best matchs your situation </p>
              <div class="row mb-3">
                <div class="col-12">
                  <div class="common-box p-2">
                    <div class="form-check pl-1">
                      <input id="1" type="radio" class="form-input-radio mr-2"/>
                      <label htmFor="1" class="text-primary fnt-smi-bld mb-0">Remind me in few days</label>
                      <p class="text-muted" style={{marginLeft: "20px"}}>We will notify you at suggested time</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <div class="common-box p-2">
                    <div class="form-check pl-1">
                      <input id="2" type="radio" class="form-input-radio mr-2"/>
                      <label htmFor="2" class="text-primary fnt-smi-bld mb-0">Family member verify</label>
                      <p class="text-muted" style={{marginLeft: "20px"}}>Parents, Siblings or wife/husband</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="common-box p-2">
                    <div class="form-check pl-1">
                      <input id="3" type="radio" class="form-input-radio mr-2"/>
                      <label htmFor="3" class="text-primary fnt-smi-bld mb-0">Im not availble </label>
                      <p class="text-muted" style={{marginLeft: "20px"}}>Not able to visit home </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                    >
                      Confirm
                    </button>
                  <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Cancel
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="dashboard custom-modal-dialog hide"
          id="whenRemindPopup"
        >
          <div className="modal-wrapper">
            <div className="modal-content candidate-tab-form p-4 no-scroll" style={{ overflow: "unset" }}>
              <h4 className="fnt-smi-bld auth-header">
                When should we remind you
              </h4>
              <span className="cstm-popup-close-btn">
              &times;
            </span>
              <p class="text-muted">We will notify with SMS & email</p>
              <div class="row mb-3">
                <div class="col-12">
                  <div class="form-group">
                    <div class="floating-label">
                      <select name="" id="" class="form-control">
                        <option value="">After 1 day</option>
                        <option value="">Aadhaar Card</option>
                        <option value="">Aadhaar Card</option>
                      </select>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                    >
                      Confirm
                    </button>
                  <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Cancel
                    </button>
                </div>
              </div>
              <center class="text-danger mt-3">Please understand delay in address verification  can delay your onboarding/offer rollout</center>
            </div>
          </div>
        </div>

        <div
          className="dashboard custom-modal-dialog hide"
          id="whomContactPopup"
        >
          <div className="modal-wrapper">
            <div className="modal-content candidate-tab-form p-4 no-scroll" style={{ overflow: "unset", maxHeight: "unset" }}>
              <h4 className="fnt-smi-bld auth-header">
                Whom should we contact
              </h4>
              <span className="cstm-popup-close-btn">
              &times;
            </span>
              <p class="text-muted">We will notify with SMS & email</p>
              <div class="row mb-3">
                <div class="col-12">
                  <div className="form-group">
                    <div className="floating-label">
                      <input type="text" className="form-control" name="name" id="name" onChange={handleFloatingLabels} />
                      <label htmlFor="name" className={formData.name && 'focused'}>Name<sup class="text-danger">*</sup></label>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div className="form-group">
                    <div className="floating-label">
                      <input type="text" className="form-control" name="email2" id="email2" onChange={handleFloatingLabels} />
                      <label htmlFor="email2" className={formData.email2 && 'focused'}>Email<sup class="text-danger">*</sup></label>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div className="form-group">
                    <div className="floating-label">
                      <input type="text" className="form-control" name="phone2" id="phone2" onChange={handleFloatingLabels} />
                      <label htmlFor="phone2" className={formData.phone2 && 'focused'}>Phone No<sup class="text-danger">*</sup></label>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div className="form-group">
                    <div class="floating-label">
                      <select name="" id="" class="form-control">
                        <option value="">Relationship Type</option>
                        <option value="">Aadhaar Card</option>
                        <option value="">Aadhaar Card</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12 form">
                  <div class="form-group">
                    <div class="form-check d-flex align-items-start p-0">
                      <input type="checkbox" id="check" class="mr-2"/>
                      <label for="check" class="text-muted">I here by nominate the person/cancel the nomination made by me previously and person mentioned below to receive the amount standing to my credit in employees provident fund in the vent of my death</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                    <button
                      className="btn btn-primary btn-lg btn-block"
                    >
                      Confirm
                    </button>
                  <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Cancel
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="dashboard custom-modal-dialog hide"
          id="thankYouPopup"
        >
          <div className="modal-wrapper">
            <div className="modal-content candidate-tab-form p-4 no-scroll" style={{ overflow: "unset" }}>
              <span className="cstm-popup-close-btn">
              &times;
            </span>
              <center>
                <img src={GreenTickBig} class="mb-3" alt=""/>
                <h3 class="fnt-bld mt-3 mb-3">Thank you</h3>
                <p class="text-muted">We will contact you afer 1 day</p>
              </center>
            </div>
          </div>
        </div>

        <div
          className="dashboard custom-modal-dialog hide"
          id="selectReasonPopup"
        >
        <div className="modal-wrapper">
          <div className="modal-content candidate-tab-form p-4 no-scroll" style={{ overflow: "unset", maxHeight: "unset" }}>
            <h4 className="fnt-smi-bld auth-header">
              Please select reason
            </h4>
            <span className="cstm-popup-close-btn">
              &times;
            </span>
            <p class="text-muted">choose what best matches your situation </p>
            <div class="row mt-0">
              <div class="col-12 form">
                <div class="form-group">
                  <div class="form-check d-flex align-items-start p-0">
                    <input type="checkbox" id="check" class="mr-2"/>
                    <label htmFor="check">House is locked</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-check d-flex align-items-start p-0">
                    <input type="checkbox" id="check2" class="mr-2"/>
                    <label htmFor="check2">Stay alone without relatives</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-check d-flex align-items-start p-0">
                    <input type="checkbox" id="check3" class="mr-2"/>
                    <label htmFor="check3">House under construction</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-check d-flex align-items-start p-0">
                    <input type="checkbox" id="check4" class="mr-2"/>
                    <label htmFor="check4">Other</label>
                  </div>
                </div>
                <div class="form-group">
                  <textarea name="" id="" rows="1" class="form-control" placeholder="Add Comment"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                  <button
                    className="btn btn-primary btn-lg btn-block mt-3"
                  >
                    Submit
                  </button>
                <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                    Cancel
                  </button>
              </div>
              <center class="text-danger mt-3">Please understand delay in address verification  can delay your onboarding/offer rollout</center>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
export default DigitalAddressVerification;
